(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-faq-page')) {
    customElements.define(
      'cc-faq-page',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const { signal } = this.controller;
          this.category = 'all';
          this.input = this.querySelector('[data-cc-faqp-input]');
          this.empty = this.querySelector('[data-cc-faqp-empty]');
          this.input?.addEventListener('input', () => this.filter(), { signal });
          this.querySelectorAll('[data-cc-faqp-filter]').forEach((button) => {
            button.addEventListener(
              'click',
              () => {
                this.category = button.dataset.ccFaqpFilter;
                this.filter();
                const layout = this.querySelector('.cc-faqp__layout');
                if (layout && layout.getBoundingClientRect().top < 0) {
                  layout.scrollIntoView({ block: 'start', behavior: 'smooth' });
                }
              },
              { signal }
            );
          });
        }

        disconnectedCallback() {
          this.controller?.abort();
        }

        normalize(text) {
          return (text || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/[’']/g, ' ');
        }

        filter() {
          const words = this.normalize(this.input?.value).split(/\s+/).filter((w) => w.length > 1);
          let shown = 0;

          this.querySelectorAll('[data-cc-faqp-filter]').forEach((button) => {
            const active = button.dataset.ccFaqpFilter === this.category;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
            if (active) {
              const title = this.querySelector('[data-cc-faqp-title]');
              if (title) title.textContent = button.dataset.ccFaqpLabel || '';
            }
          });
          // Une seule catégorie : son nom passe dans le titre du haut, on masque le titre du groupe
          this.querySelector('.cc-faqp__main')?.classList.toggle('is-single', this.category !== 'all');

          this.querySelectorAll('[data-cc-faqp-group]').forEach((group) => {
            const inCategory = this.category === 'all' || group.dataset.ccFaqpGroup === this.category;
            let visible = 0;
            group.querySelectorAll('details').forEach((details) => {
              const row = details.closest('accordion-custom') || details;
              const match = inCategory && words.every((w) => this.normalize(details.textContent).includes(w));
              row.hidden = !match;
              if (match) visible += 1;
            });
            group.hidden = visible === 0;
            shown += visible;
          });

          if (this.empty) this.empty.hidden = shown > 0;
          const count = this.querySelector('[data-cc-faqp-count]');
          if (count) count.textContent = String(shown);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-faq-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-faq-search')) {
    customElements.define(
      'cc-faq-search',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-cc-faq-input]');
          this.count = this.querySelector('[data-cc-faq-count]');
          this.empty = this.querySelector('[data-cc-faq-empty]');
          this.ownSection = this.closest('.shopify-section');
          this.input.addEventListener('input', () => this.filter());
        }

        normalize(text) {
          return (text || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/[’']/g, ' ');
        }

        filter() {
          const words = this.normalize(this.input.value).split(/\s+/).filter((w) => w.length > 1);
          const main = this.closest('main') || document;
          let shown = 0;
          let total = 0;

          main.querySelectorAll('.shopify-section').forEach((section) => {
            if (section === this.ownSection) return;
            const rows = section.querySelectorAll('.accordion details');
            if (!rows.length) return;
            let visibleInSection = 0;

            rows.forEach((details) => {
              const row = details.closest('accordion-custom') || details;
              const match = words.every((w) => this.normalize(details.textContent).includes(w));
              row.hidden = !match;
              total += 1;
              if (match) visibleInSection += 1;
            });

            section.hidden = visibleInSection === 0;
            shown += visibleInSection;
          });

          const searching = words.length > 0;
          this.empty.hidden = !searching || shown > 0;
          this.count.textContent = searching && shown > 0 ? `${shown} / ${total}` : '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-galerie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRail = (rail) => {
      if (rail.dataset.ccReady) return;
      rail.dataset.ccReady = '1';
      const track = rail.querySelector('[data-cc-track]');
      const prev = rail.querySelector('.cc-galerie__arrow--prev');
      const next = rail.querySelector('.cc-galerie__arrow--next');
      if (!track || !prev || !next) return;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        rail.classList.toggle('is-scrollable', max > 2);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.9 });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    };

    const scan = () => document.querySelectorAll('.cc-galerie [data-cc-rail]').forEach(initRail);
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ccReady) return;
      const slides = [...root.querySelectorAll('.cc-hero__slide')];
      if (!slides.length) return;
      root.dataset.ccReady = '1';
      const interval = Number(root.dataset.interval) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const hero = root.closest('.cc-hero') || root;
      // Texte de chaque image : le sien s'il en a un (template du bloc), sinon celui de la section
      const content = hero.querySelector('.cc-hero__content');
      const base = content?.querySelector('[data-cc-hero-panel]') || null;
      const panels = slides.map((slide, n) => {
        const tpl = slide.querySelector('template[data-cc-hero-panel]');
        if (n === 0 || !content || !(tpl instanceof HTMLTemplateElement)) return base;
        const panel = tpl.content.firstElementChild?.cloneNode(true);
        if (!(panel instanceof HTMLElement)) return base;
        content.append(panel);
        return panel;
      });
      if (panels.some((p) => p && p !== base)) hero.classList.add('cc-hero--multi');
      let dots = [];
      let index = 0;
      let timer;

      if (slides.length > 1) {
        const nav = document.createElement('div');
        nav.className = `cc-hero__dots cc-hero__dots--${root.dataset.dots || 'center'}`;
        nav.setAttribute('role', 'tablist');
        nav.setAttribute('aria-label', 'Images');
        dots = slides.map((_, n) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'cc-hero__dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', `Image ${n + 1} sur ${slides.length}`);
          d.addEventListener('click', () => { go(n); start(); });
          nav.append(d);
          return d;
        });
        root.append(nav);
      }

      const go = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => {
          s.classList.toggle('is-active', n === index);
          s.toggleAttribute('aria-hidden', n !== index);
        });
        dots.forEach((d, n) => {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-selected', n === index);
        });
        new Set(panels).forEach((p) => {
          if (!p) return;
          const on = p === panels[index];
          p.classList.toggle('is-active', on);
          p.toggleAttribute('inert', !on);
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (slides.length > 1 && interval > 0 && !reduce) timer = setInterval(() => go(index + 1), interval);
      };

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      // Mobile : glisser vers la gauche ou la droite change d'image (sur toute la héros, texte compris)
      if (slides.length > 1) {
        let x0 = null;
        let y0 = 0;
        hero.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
          stop();
        }, { passive: true });
        hero.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const t = e.changedTouches[0];
          const dx = t.clientX - x0;
          const dy = t.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(index + (dx < 0 ? 1 : -1));
          start();
        }, { passive: true });
      }
      // Éditeur : afficher l'image sélectionnée
      slides.forEach((s, n) => s.addEventListener('shopify:block:select', () => { stop(); go(n); }));
      go(0);
      start();
    };

    const scan = () => document.querySelectorAll('[data-cc-hero-carousel]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRail = (rail) => {
      if (rail.dataset.ccReady) return;
      rail.dataset.ccReady = '1';
      const track = rail.querySelector('[data-cc-track]');
      const prev = rail.querySelector('.cc-reviews__arrow--prev');
      const next = rail.querySelector('.cc-reviews__arrow--next');
      if (!track || !prev || !next) return;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        rail.classList.toggle('is-scrollable', max > 2);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.9 });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    };

    const scan = () => {
      document.querySelectorAll('.cc-reviews [data-cc-rail]').forEach(initRail);
    };
    scan();
    document.addEventListener('shopify:section:load', scan);

    // La note (ex. 4,8) monte depuis 0 quand elle arrive à l'écran
    const countRating = () => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('[data-cc-count-up-rating]:not([data-cc-counted])').forEach((el) => {
        el.dataset.ccCounted = '';
        const target = parseFloat(el.textContent.replace(',', '.'));
        if (!target) return;
        const fmt = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        el.textContent = fmt.format(0);
        new IntersectionObserver((entries, io) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min((now - start) / 1400, 1);
            el.textContent = fmt.format(target * (1 - Math.pow(1 - t, 3)));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }, { threshold: 0.5 }).observe(el);
      });
    };
    countRating();
    document.addEventListener('shopify:section:load', countRating);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const fmt = new Intl.NumberFormat("fr-FR");
    const ease = (t) => 1 - Math.pow(1 - t, 3);

    const run = (list) => {
      const items = [...list.querySelectorAll(".cc-stats__value")].flatMap((el) => {
        const text = el.textContent;
        const m = text.match(/\d+(?:[\s\u202f]\d{3})*/);
        const target = m ? parseInt(m[0].replace(/\D/g, ""), 10) : 0;
        // Rien à compter pour 0 ni pour une année
        if (!target || /^(19|20)\d\d$/.test(m[0])) return [];
        const before = text.slice(0, m.index);
        const after = text.slice(m.index + m[0].length);
        const label = document.createElement("span");
        label.className = "visually-hidden";
        label.textContent = text.trim();
        el.after(label);
        el.setAttribute("aria-hidden", "true");
        el.textContent = before + "0" + after;
        return [{ el, target, before, after }];
      });
      if (!items.length) return;

      new IntersectionObserver((entries, io) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        const start = performance.now();
        const tick = (now) => {
          let done = true;
          items.forEach(({ el, target, before, after }, i) => {
            const t = Math.min(Math.max((now - start - i * 120) / 1600, 0), 1);
            if (t < 1) done = false;
            el.textContent = before + fmt.format(Math.round(target * ease(t))) + after;
          });
          if (!done) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.4 }).observe(list);
    };

    const init = (root) => root.querySelectorAll("[data-cc-count-up]:not([data-cc-counted])").forEach((list) => {
      list.dataset.ccCounted = "";
      run(list);
    });
    init(document);
    document.addEventListener("shopify:section:load", (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
